import { Report198 } from "../../../components/borrowSystem/Report/Report198";
import { HeadTitle } from "../../../components/share/HeadTitle";
import { Footer } from "../../../components/share/Footer";
import { NavbarBorrowSystem } from "../../../components/share/NavbarBorrowSystem";

export function Report198Container() {
  const titleName =
    "สรุปข้อมูลการพัฒนาฝีมือแรงงากจากการกู้ยืมเงินกองทุนพัฒนาฝีมือแรงงาน"; //ใส่ชื่อtitle ตรงนี้
  return (
    <div className="page-container bg-landing">
      <NavbarBorrowSystem />
      <HeadTitle title={titleName} />
      <Report198 />
      <Footer />
    </div>
  );
}
